import Dexie from 'dexie';

export const db = new Dexie('PayHubDB');

db.version(1).stores({
  clients: 'id, full_name, cpf, status, situacao, last_invoice_date',
  payments: 'id, client_id, reference_month, due_date, status, payment_type',
  charges: 'id, client_id, reference_month, due_date, status, payment_type',
  campaigns: 'id, name, status',
  conversations: 'id, status, assigned_to',
  pendingSync: '++id, url, method, body, createdAt',
});

export async function clearCache() {
  await db.clients.clear();
  await db.payments.clear();
  await db.charges.clear();
  await db.campaigns.clear();
  await db.conversations.clear();
}